<template>
  <modal
    width="35"
    :show-modal="showModal"
    @close-modal="closeModal"
    title="Account Managers"
  >
    <div>
      <p class="text-sm">All users assigned to this customer</p>
    </div>
    <div class="py-6">
      <ol
        class="text-sm"
        v-for="manager in contact.accountManager"
        :key="manager.id"
      >
        <li>
          <span class="font-semibold">{{ manager.name }}</span> <br />
          <span>{{ manager.phoneNumber }}, {{ manager.email }}</span>
        </li>
      </ol>
    </div>
    <div class="flex justify-between">
      <div>
        <p class="cursor-pointer" @click="closeModal">Close</p>
      </div>
      <div>
        <primary-button
          buttonText="Settings"
          @click="$emit('show-settings'), closeModal"
        />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      required: true,
      type: Boolean,
    },
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      accountManager: {
        name: "",
        phoneNumber: "",
        email: "",
      },
      loading: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
ol {
  list-style-type: initial;
}
</style>
